module.exports = __webpack_public_path__ + "img/avatar.5ad55957.png";